@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Maryland</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <p>{{ textValues?.Lead_Text }}</p>
      <!-- Taxi cab Radio buttons -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[0].formControlName)?.value === null ||
              reactiveForm.get(controls[0].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span class="axis-error-block">Please select an option.</span>
            }
          }
        </div>
      }
      <!-- UMBI & UMPD Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[1].formControlName)?.value === null ||
              reactiveForm.get(controls[1].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }
      <!-- UMBI & UMPD Radio Group level three -->
      @if (controls?.length > 3) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[2].formControlName)?.value === null ||
              reactiveForm.get(controls[2].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[2].formControlName)?.touched) {
              @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }
      <!-- UMBI Dropdowns -->
      <div class="axis-grid _ml-xlarge">
        @for (control of controls | slice: 3 : 9; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                  (onSelect)="onSelect(baseRules['selectionId'], control.formControlName)"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      @let L1_CTRL = controls[0].formControlName;
      @let l1Val = reactiveForm?.get(L1_CTRL)?.value;
      @let l1Key = (l1Val?.select ?? l1Val?.value ?? l1Val) || "";
      @if (
        l1Key === "Buses_LevelOne_Radio" ||
        l1Key === "Taxicabs_LevelOne_Radio" ||
        l1Key === "BusesTaxicabs_LevelOne_Radio"
      ) {
        @if ((baseRules?.["Reject_LevelTwo_Radio"] ?? "").includes("Yes")) {
          <div class="axis-grid">
            <div class="axis-col-sm-6 axis-col-md-4">
              <div class="axis-form-group">
                <label
                  class="axis-control-label"
                  id="reject_leveltwo_radio-pdffield-maryland"
                  >{{ textValues?.Reject_Text }}</label
                >
              </div>
            </div>
          </div>
        }
      }
        @if ((baseRules?.["UMBI_UMPD_CombinedSingleMinLimit_DropDown"] ?? "").includes("readonly")) {
          <div class="axis-grid">
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[8].label }}</label>
                <div id="umbi_umpd_combinedsingleminlimit_75k-pdffield-maryland">
                  {{ controls[8].data[0]?.name }}
                </div>
              </div>
            </div>
          </div>
        }
        @if (
          (baseRules?.["UMBI_SplitMinLimits_DropDown"] || "").includes("readonly") &&
          (baseRules?.["UMPD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")
        ) {
          <div class="axis-grid">
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[5].label }}</label>
                <div id="umbi_splitminlimits_30k_60k-pdffield-maryland">{{ controls[5].data[0].name }}</div>
              </div>
            </div>
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[6].label }}</label>
                <div id="umpd_combinedsingleminlimit_15k-pdffield-maryland">{{ controls[6].data[0].name }}</div>
              </div>
            </div>
          </div>
        }
    </form>
    <p>{{ textValues?.description }}</p>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Maryland</h2>
  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 4 : 12; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
}
